import * as ActionTypes from '../ActionTypes';
export const PythonApiAction = (params) => {
    return {
        type: ActionTypes.ATS_RESUME_PYTHON_API_REQUEST,
        params
    }
}

export const PythonResetApiAction = (params) => {
    return {
        type: ActionTypes.ATS_RESUME_PYTHON_API_RESET ,
        params
    }
}

export const EmpPicPythonApiAction = (params) => {
    return {
        type: ActionTypes.EMP_PROFILE_PIC_PYTHON_API_REQUEST,
        params
    }
}

export const EmpPicPythonResetApiAction = (params) => {
    return {
        type: ActionTypes.EMP_PROFILE_PIC_PYTHON_API_RESET ,
        params
    }
}
